import { useFragment, graphql } from 'react-relay';
import { useShowPricingGuidance } from './useShowPricingGuidance';

import { useShowSoldPricingGuidance_item$key } from './__generated__/useShowSoldPricingGuidance_item.graphql';

const itemFragment = graphql`
    fragment useShowSoldPricingGuidance_item on Item {
        ...useShowPricingGuidance_item
        pricingGuidance(
            isTrade: $isTrade
            buyerId: $userId
            userCountryCode: $userCountryCode
            priceBookName: $priceBookName
        ) {
            pricingGuidanceType
        }
    }
`;

export const useShowSoldPricingGuidance = ({
    item: itemRef,
    currency,
}: {
    item?: useShowSoldPricingGuidance_item$key | null;
    currency: string;
}): boolean => {
    const item = useFragment(itemFragment, itemRef);
    const { pricingGuidanceType } = item?.pricingGuidance || {};

    const showPricingGuidance = useShowPricingGuidance({ item, currency });

    if (pricingGuidanceType === 'MARKETPLACE_RETAIL') {
        return showPricingGuidance;
    }

    return false;
};
